<template>
    <okraina-view :class="'okraina-v-shopping-list'" @refresh="refresh" ref="view" :showBack="false">

        <template v-slot:header>
            <h1 class="title">
                Список покупок
            </h1>
        </template>

        <template v-slot:header-right v-if="items.length > 0">
            <div class="btn slim btn1" @click="onClearClick">
                Очистить
            </div>
        </template>

        <template v-slot:content>

            <!-- Магазин выбран -->
            <template v-if="retailShopId">

                <!--Индикатор загрузки-->
                <transition>
                    <okraina-loader-page v-show="loading" />
                </transition>

                <template v-if="!loading">

                    <br />

                    <div class="notice">
                        <div class="inner">
                            Список покупок представлен в информационных целях. Совершить покупку Вы можете в фирменном
                            магазине.
                        </div>

                    </div>

                    <transition>
                        <okraina-overlay v-show="showOverlay" :fixed="true" />
                    </transition>

                    <!--Если корзина не пуста-->
                    <template v-if="items.length > 0">

                        <!--Позиции-->
                        <div class="items">
                            <transition-group name="fade">
                                <okraina-retail-cart-item v-for="item in items" :key="item.ID" :item="item"
                                    :product="getProductByItem(item)" @deleted="onItemDeleted" />
                            </transition-group>
                        </div>

                        <!--Итого-->
                        <okraina-retail-cart-total :items="items" :products="products" />

                        <div class="padding-order"></div>

                        <!--Оформить заказ-->
                        <okraina-fixed-panel v-if="requestWebFormId">
                            <div class="btn btn1 btn-block" @click="onRequestShowClick">Заявка на самовывоз</div>
                        </okraina-fixed-panel>

                    </template>

                    <!--Иначе корзина пуста-->
                    <template v-else>
                        <div class="cart-empty">
                            <div class="picture" :style="{ 'background-image': 'url(' + imageCartEmpty + ')' }"></div>
                            <div class="caption">Ваша корзина пуста</div>
                            <div class="details">
                                Перейдите в каталог или воспользуйтесь поиском, чтобы продолжить свои покупки
                            </div>
                        </div>
                    </template>

                </template>

            </template>

            <!-- иначе требуем выбрать розничный магазин-->
            <template v-else>
                <br /><br />
                <okraina-retail-store-not-selected />
            </template>

            <!-- форма заявки -->
            <okraina-sheet v-model:visible="showRequestForm" :maxHeight="90">
                <template v-slot:body>
                    <okraina-web-form class="okraina-retail-request-form" :id="requestWebFormId" :sheetMode="true"
                        :profileFields="{ NAME: 'NAME', EMAIL: 'EMAIL', PHONE: 'PERSONAL_PHONE' }"
                        :extData="webFormExtData" @onAdd="onRequestSent">

                        <template v-slot:top v-if="shop">
                            <div class="shop">
                                <div class="label">Адрес магазина</div>
                                <div class="value">{{ shop.PROPS.ADDRESS }}</div>
                            </div>

                        </template>

                    </okraina-web-form>
                </template>
            </okraina-sheet>


        </template>
    </okraina-view>
</template>

<script>
import okrainaView from "@/components/view2.vue";
import okrainaLoaderPage from "@/components/loader.page.vue";
import okrainaOverlay from "@/components/overlay.vue";
import okrainaRetailCartItem from "@/components/retail/cart.item.vue";
import okrainaRetailCartTotal from "@/components/retail/cart.total.vue";
import okrainaRetailStoreNotSelected from "@/components/retail/store.not.selected.vue";
import okrainaFixedPanel from '@/components/fixed.panel.vue'
import okrainaSheet from "@/components/sheet.vue"
import okrainaWebForm from "@/components/web.form.vue"
import okrainaControlInput from "@/components/controls/input.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import tools from "@/plugins/tools";

import imageCartEmptyPath from "@/assets/images/cart-empty.svg";

import { mapGetters } from "vuex";

export default {

    name: "okraina-v-shopping-list",

    components: {
        okrainaView,
        okrainaLoaderPage,
        okrainaOverlay,
        okrainaRetailCartItem,
        okrainaRetailCartTotal,
        okrainaRetailStoreNotSelected,
        okrainaFixedPanel,
        okrainaSheet,
        okrainaWebForm,
        okrainaControlInput
    },

    data() {
        return {
            loading: true,
            items: [],
            products: [],
            showOverlay: false,
            imageCartEmpty: imageCartEmptyPath,
            showRequestForm: false,
            shop: false
        }
    },

    computed: {

        ...mapGetters({
            retailShopId: "retail/getShopId",
            basket: "retail/getShopBasket",
            siteSettings: "getSiteSettings"
        }),

        requestWebFormId() {
            return this.siteSettings ? this.siteSettings.FORM_PICKUP_REQUESTS : "";
        },

        webFormExtData() {
            return {
                SHOP_ID: this.retailShopId
            }
        }
    },

    watch: {

        basket: {
            handler() {

                this.showOverlay = true;
                this.loadData(() => { this.showOverlay = false });

            },
            deep: true
        },

        retailShopId: function () {
            this.loadData();
            this.shop = false;
            this.loadShop();
        }

    },

    methods: {

        /**
         * Загружает данные
         */
        loadData(resolve = false) {

            //если магазин не выбран
            if (!this.retailShopId) {
                if (resolve) {
                    resolve();
                }
                return;
            }

            if (!this.loading) {
                this.loading = resolve ? false : true;
            }

            rest
                .call("retail.basket.getlist", {
                    method: "post",
                    data: {
                        FILTER: {
                            SHOP_ID: this.retailShopId
                        },
                        PAGING: {
                            SIZE: 200,
                            PAGE: 1
                        },
                        INCLUDE_PRODUCTS: "Y",
                        SHOP_ID: this.retailShopId,
                        RESIZE_OPTIONS: tools.getProductListResizeOptions(),
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        this.items = data.ITEMS;
                        this.products = data.PRODUCTS;
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                })
                .finally(() => {
                    if (resolve) {
                        resolve();
                    }
                    this.loading = false;
                });
        },

        /**
         * Перезагрузка экрана
         */
        refresh(resolve) {
            this.loadData(resolve);
        },

        /**
         * Получает по позиции корзины товар
         */
        getProductByItem(item) {
            let product = this.products.find(p => p.FIELDS.ID == item.PRODUCT_ID);
            if (product) {
                return product;
            }
            return false;
        },

        /**
         * Обработка удаления позиции
         */
        onItemDeleted(id) {
            let item = this.items.find(i => i.ID == id);
            if (!item) {
                return;
            }
            var index = this.items.indexOf(item);
            if (index !== -1) {
                this.items.splice(index, 1);
            }
        },

        /**
         * Клик по кнопке "Очистить"
         */
        onClearClick() {

            let vm = this;
            //спросим а нужно ли закрывать приложение
            bus.emit("OKRAINA_CONFIRM_E_SHOW", {
                message: "Вы действительно хотите очистить список?",
                resolveText: "Да",
                rejectText: "Нет",
                resolve: function (value) {
                    if (value) {
                        vm.clear();
                    }
                },
                reverse: false,
            });

        },

        /**
         * Очистка списка
         */
        clear() {

            rest
                .call("retail.basket.clear", {
                    method: "post",
                    data: {
                        SHOP_ID: this.retailShopId
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {

                        //изменяем кол-во в корзине
                        this.$store.dispatch("retail/clear")

                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                });


        },

        /**
         * Клик по кнопке "Заявка на самовывоз"
         */
        onRequestShowClick() {
            this.showRequestForm = true;
        },

        /**
         * Обработка успешной отрпавки формы
         */
        onRequestSent() {
            this.clear();
        },

        /**
         * Загружает текущий выбранный магазин
         */
        loadShop() {

            rest
                .call("company.shops", {
                    method: "post",
                    data: {
                        SELECT: ["ID", "NAME"],
                        FILTER: {
                            "!PROPERTY_AVAILABLE_IN_APP": false,
                            "ID": this.retailShopId
                        },
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        if (data.ITEMS.length > 0) {
                            this.shop = data.ITEMS[0];
                        }
                    }
                });
        },
    },

    created() {
        this.loadData();
        this.loadShop();
    },

    mounted() {
        bus.on("OKRAINA_MENU_E_PRESSING_ITEM_AGAIN", this.$refs.view.scrollTop)
    },

    beforeUnmount() {
        bus.off("OKRAINA_MENU_E_PRESSING_ITEM_AGAIN", this.$refs.view.scrollTop)
    },
}
</script>

<style lang="scss">
.okraina-v-shopping-list {

    .notice {
        position: relative;
        margin-bottom: 20px;
        padding: 12px 20px;


        text-align: center;
        border-radius: 24px;

        &::before {
            content: "";
            position: absolute;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            background: rgba(var(--color-error-rgb), 0.05);
        }

        .inner {
            position: relative;
            z-index: 2;
            font-weight: 500;
            font-size: 12px;
            color: var(--color-error-rgb);
            line-height: 1.2;
        }
    }

    .cart-empty {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 250px;
        text-align: center;

        .picture {
            margin: 0px auto 35px;
            width: 111px;
            height: 98px;
            background-size: contain;
            background-position: center center;
            transform: translateX(-10px);
        }

        .caption {
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 15px;
        }

        .details {
            font-size: 13px;
        }
    }

    .padding-order {
        height: 60px;
    }
}

.okraina-retail-request-form {
    .shop {
        margin-bottom: 15px;

        .label {
            font-weight: 500;
            font-size: 10px;
            color: var(--color-control-label);
            margin-bottom: 8px;
        }

        .value {
            font-size: 14px;
            font-weight: 500;
        }
    }
}
</style>